import React from "react";
import { IdentityResponsibleDocumentInputsProps } from "@/screen/Identities/IdentityResponsibleDocumentInputs/Interfaces/IdentityResponsibleDocumentInputsInterfaces";
import IdentityAttachmentPreview from "@/screen/Identities/components/IdentityAttachmentPreview";
import { FormSection, FormRow, FormField, FormLabel, FormInput, TallDocumentPreview } from "@/screen/Identities/IdentityResponsibleDocumentInputs/Styles/IdentityResponsibleDocumentInputsStyles";

const PLACEHOLDER_PROOF_OF_MINOR_GUARDIAN = "Documento del tutor legal";

const IdentityResponsibleDocumentInputs: React.FC<IdentityResponsibleDocumentInputsProps> = ({proofOfMinorGuardian, validation, highlightPendingManualFields, isFormLocked, onProofOfMinorGuardianChange}) =>
{
    const ph = highlightPendingManualFields && !validation.proofOfMinorGuardian;
    const proofOfMinorGuardianSource = proofOfMinorGuardian instanceof File || typeof proofOfMinorGuardian === "string" ? proofOfMinorGuardian : null;

    return(
        <FormSection>
            <h3>Documentación del Responsable</h3>
            <p style={{color: "#5f7172", marginBottom: "15px", cursor: "default"}}>
                Es obligatorio adjuntar un documento que acredite la mayoría de edad del responsable del menor.
            </p>
            <FormRow>
                <FormField style={{flex: "1"}}>
                    <FormLabel required>Documento de prueba de mayoría de edad</FormLabel>
                    <FormInput type="file" name="proofOfMinorGuardian" accept=".pdf,.jpg,.jpeg,.png"
                        onChange={(e) =>
                        {
                            const file = e.target.files?.[0] || null;
                            onProofOfMinorGuardianChange(file);
                        }}
                        disabled={isFormLocked}
                        autoComplete="off"
                        $pendingHighlight={ph}
                    />
                    <TallDocumentPreview>
                        <IdentityAttachmentPreview
                            source={proofOfMinorGuardianSource}
                            alt={PLACEHOLDER_PROOF_OF_MINOR_GUARDIAN}
                            placeholder={null}
                        />
                    </TallDocumentPreview>
                </FormField>
            </FormRow>
        </FormSection>
    );
};

export default IdentityResponsibleDocumentInputs;